import { render, staticRenderFns } from "./Ventas.vue?vue&type=template&id=33491d0d&scoped=true&"
import script from "./Ventas.vue?vue&type=script&lang=js&"
export * from "./Ventas.vue?vue&type=script&lang=js&"
import style0 from "./Ventas.scss?vue&type=style&index=0&id=33491d0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33491d0d",
  null
  
)

export default component.exports